<template>
  <router-view />
</template>

<script>

export default {
  name: 'OfficeWrapper'
}
</script>
